import { useGameStore } from '../state/store.js';
import { TICKS_PER_SECOND, TARGET_FPS } from '@settlers/shared';

/** Live performance & simulation readout (Sprint 1 profiler stub). */
export const DebugOverlay = (): React.JSX.Element => {
  const t = useGameStore((s) => s.telemetry);
  const fpsClass = t.fps >= TARGET_FPS - 5 ? 'good' : t.fps >= 40 ? 'warn' : 'bad';
  const tpsClass = t.tps >= TICKS_PER_SECOND - 1 ? 'good' : 'warn';

  return (
    <div className="panel debug">
      <div className="panel-title">Debug</div>
      <Row label="FPS" value={`${t.fps} / ${TARGET_FPS}`} cls={fpsClass} />
      <Row label="TPS" value={`${t.tps} / ${TICKS_PER_SECOND}`} cls={tpsClass} />
      <Row label="Tick" value={t.tick.toLocaleString()} />
      <Row label="Entities" value={t.entityCount.toLocaleString()} />
      <Row label="Workers" value={t.workers.toLocaleString()} />
      <Row label="Roads" value={t.roads.toLocaleString()} />
      <Row label="Trips" value={t.trips.toLocaleString()} />
      <Row label="Zoom" value={`${t.zoom.toFixed(2)}×`} />
      <Row label="Chunks" value={`${t.visibleChunks} / ${t.chunks}`} />
    </div>
  );
};

const Row = ({ label, value, cls }: { label: string; value: string; cls?: string }): React.JSX.Element => (
  <div className="row">
    <span className="row-label">{label}</span>
    <span className={`row-value ${cls ?? ''}`}>{value}</span>
  </div>
);
